import Modal from '@mui/material/Modal';
import React, { useState } from 'react';
import { getFormattedPrice } from '../../helpers/price';
import { open } from '../../helpers/wompi';
import Button from '../core/Button';
import styles from './AcceptOfferModal.module.scss';

export interface Props {
  open: boolean;
  data: any;
  property: any;
  //onSubmit: () => void;
  onClose: () => void;
}

export default function PurchasePropertyModal(props: Props) {
  if (!props.open) {
    return null;
  }

  const handleWompiPay = (reservedPrice: number, chatObj: any) => {
    props.onClose();
    open({
      reference: `${chatObj.property.id}_${Math.round(Math.random() * 9999)}`,
      chatId: chatObj.id,
      amountInPesos: reservedPrice,
    });
  };

  const [check, setCheck] = useState(false);
  const [msgError, setMsgError] = useState('');

  return (
    <Modal open className={styles.container} onClose={props.onClose}>
      <div className={styles.content}>
        <h1>Separar propiedad</h1>
        <>
          <p>
            Para continuar, debes cancelar el valor de separación
            <b>
              {getFormattedPrice(props.data.property.reservedPrice, {
                prefix: ' ',
                sufix: ' ',
              })}
            </b>
            y tendrás {props.data.property.reservedDays} días para completar el
            proceso.
          </p>
          <div>
            <p>
              <b>RECUERDA VOLVER AL COMERCIO PARA COMPLETAR LA SEPARACIÓN</b>
            </p>
          </div>
          <div className={styles.checkbox}>
            <input onInput={() => setCheck((prev) => !prev)} type="checkbox" />{' '}
            Aceptas los terminos y condiciones de la compra
          </div>
          <Button
            label="SEPARAR"
            style={{ marginRight: 5 }}
            onClick={() => {
              if (check) {
                handleWompiPay(props.data.property.reservedPrice, props.data);
                setMsgError('');
              } else {
                setMsgError(
                  'Debes aceptar los terminos y condiciones para continuar'
                );
              }
            }}
          />
          <Button
            style={{ marginLeft: 10 }}
            label="CANCELAR"
            onClick={props.onClose}
          />
          <div style={{ marginTop: '10px' }}>
            <p>
              <b style={{ color: 'red' }}>{msgError}</b>
            </p>
          </div>
        </>
      </div>
    </Modal>
  );
}
